import { render } from "./welcome.vue?vue&type=template&id=18974c36&scoped=true"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"

import "./welcome.vue?vue&type=style&index=0&id=18974c36&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kenyo\\Documents\\dev\\passwords\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18974c36"]])

export default __exports__